import { Skeleton } from "@/components/ui/skeleton";

const TREE_SKELETON_ROWS = [
  { width: "72%", indent: 12, hasChevron: true, icon: 14 },
  { width: "58%", indent: 30, hasChevron: true, icon: 14 },
  { width: "54%", indent: 48, hasChevron: false, icon: 16 },
  { width: "66%", indent: 30, hasChevron: false, icon: 16 },
  { width: "62%", indent: 12, hasChevron: true, icon: 14 },
  { width: "48%", indent: 30, hasChevron: false, icon: 16 },
];

export const SkillCollectionWorkspaceSkeleton = () => (
  <div className="flex h-full min-h-0 flex-1 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm shadow-gray-950/5">
    <div className="flex w-[276px] shrink-0 flex-col border-r border-gray-200 bg-white">
      <div className="flex h-[37px] items-center border-b border-gray-200 bg-gray-50/70 px-3">
        <span className="text-sm font-medium text-gray-700">Files</span>
      </div>
      <div className="flex-1 space-y-1.5 p-3">
        {TREE_SKELETON_ROWS.map(row => (
          <div
            key={`${row.width}-${row.indent}-${row.icon}-${row.hasChevron}`}
            className="flex min-h-8 items-center gap-1.5 rounded-lg px-2.5 py-1.5"
            style={{ paddingLeft: `${row.indent}px` }}
          >
            {row.hasChevron ? (
              <Skeleton className="shrink-0 rounded-sm" width="14px" height="14px" />
            ) : (
              <div className="w-[14px] shrink-0" />
            )}
            <Skeleton
              className="shrink-0 rounded-sm"
              width={`${row.icon}px`}
              height={`${row.icon}px`}
            />
            <Skeleton className="h-4" width={row.width} />
          </div>
        ))}
      </div>
      <div className="border-t border-gray-200 px-3 py-2">
        <Skeleton className="h-4 w-24" />
      </div>
    </div>
    <div className="flex min-w-0 flex-1 flex-col">
      <div className="flex h-[37px] items-center gap-3 border-b border-gray-200 bg-gray-50/70 px-3">
        <Skeleton className="h-4 w-40" />
      </div>
      <div className="flex min-h-0 flex-1 flex-col gap-4 p-5">
        <div>
          <Skeleton className="mb-3 h-8 w-52" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-full max-w-[620px]" />
            <Skeleton className="h-4 w-[80%]" />
            <Skeleton className="h-4 w-[68%]" />
          </div>
        </div>
        <div>
          <Skeleton className="mb-3 h-6 w-36" />
          <div className="space-y-2.5">
            <div className="flex items-center gap-3">
              <Skeleton className="h-2.5 w-2.5 rounded-full" />
              <Skeleton className="h-4 w-[46%]" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-2.5 w-2.5 rounded-full" />
              <Skeleton className="h-4 w-[54%]" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-2.5 w-2.5 rounded-full" />
              <Skeleton className="h-4 w-[40%]" />
            </div>
          </div>
        </div>
        <div>
          <Skeleton className="mb-3 h-6 w-32" />
          <div className="rounded-lg border border-gray-200/80 p-4">
            <div className="mb-3 flex gap-3">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-20" />
            </div>
            <div className="space-y-2">
              <div className="flex gap-3">
                <Skeleton className="h-8 w-[34%]" />
                <Skeleton className="h-8 w-[30%]" />
                <Skeleton className="h-8 w-[26%]" />
              </div>
              <div className="flex gap-3">
                <Skeleton className="h-8 w-[34%]" />
                <Skeleton className="h-8 w-[30%]" />
                <Skeleton className="h-8 w-[26%]" />
              </div>
              <div className="flex gap-3">
                <Skeleton className="h-8 w-[34%]" />
                <Skeleton className="h-8 w-[30%]" />
                <Skeleton className="h-8 w-[26%]" />
              </div>
            </div>
          </div>
        </div>
        <div>
          <Skeleton className="mb-3 h-5 w-28" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-full max-w-[560px]" />
            <Skeleton className="h-4 w-[94%]" />
            <Skeleton className="h-4 w-[90%]" />
            <Skeleton className="h-4 w-[72%]" />
          </div>
        </div>
        <div>
          <Skeleton className="mb-3 h-6 w-44" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-full max-w-[540px]" />
            <Skeleton className="h-4 w-[86%]" />
            <Skeleton className="h-4 w-[74%]" />
          </div>
        </div>
      </div>
    </div>
  </div>
);
